import { render, staticRenderFns } from "./parcelle_proprietaire_contact.vue?vue&type=template&id=b45e4826"
import script from "./parcelle_proprietaire_contact.js?vue&type=script&lang=js&external"
export * from "./parcelle_proprietaire_contact.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports